module.exports = __webpack_public_path__ + "media/img/event/Scholarships2u_thumbs-up-96bc8df2cbb0b65cec7039a220e49e11.svg";